import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

export const UserStatusCell = ({ value }) => {
  if (value === undefined) {
    return <Text size={11}>-</Text>
  }
  return <Text size={11}>{value ? 'Active' : 'Disabled'}</Text>
}

UserStatusCell.propTypes = {
  value: PropTypes.bool,
}
